<template>
  <div class="inventory">
    <div class="search">
      <el-form ref="searchForm" :model="searchForm" label-width="80px">
        <div class="row">
          <el-form-item label="仓库：" prop="warehouseId" class="customer-form">
            <el-select 
              class="white"
              clearable
              v-model="searchForm.warehouseId"
              placeholder="请选择仓库"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货主：" prop="customerId">
            <el-select 
              class="white"
              clearable
              v-model="searchForm.customerId"
              placeholder="请选择货主"
              @change="changeCustomerList"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="项目名称："
            prop="projectId"
          >
            <el-select
              class="gray white"
              v-model="searchForm.projectId"
              placeholder="请选择项目"
            >
              <el-option
                v-for="item in projectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="日期：" prop="date" class="customer-form">
            <el-date-picker
              v-model="searchForm.date"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
            ></el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button class="btn-blue" @click="search">搜索</el-button>
            <el-button class="btn-white" @click="resetForm('searchForm')">清空</el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="operation-btn">
        <el-button
          class="btn-white entry"
          icon="el-icon-download"
          @click="openEntry"
          >录入</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table ref="table" :data="tableData" style="width: 100%">
        <el-table-column
          v-for="(item, index) in tableTitleList"
          :key="index"
          :prop="item.prop"
          :label="item.label"
          show-overflow-tooltip
          :min-width="item.width"
        ></el-table-column>
        <el-table-column label="库存区">
          <el-table-column
            prop="stockInventorySurplus"
            label="盘盈"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="stockInventoryLoss"
            label="盘亏"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table-column>
        <el-table-column label="拣选区">
          <el-table-column
            prop="pickingInventorySurplus"
            label="盘盈"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="pickingInventoryLoss"
            label="盘亏"
            width="100"
            show-overflow-tooltip
          >
          </el-table-column>
        </el-table-column>
        <el-table-column
          prop="stockDifference"
          label="库存总差异"
          min-width="120"
          show-overflow-tooltip
        >
        </el-table-column>
      </el-table>
      <div class="pagination">
        <pagination-tpl
          :total="total"
          :currentPage="currentPage"
          :pageSize="pageSize"
          @queryChange="queryChange"
        ></pagination-tpl>
      </div>
    </div>


    
    <!-- 录入 -->
    <el-dialog
      title="录入"
      top="12vh"
      :visible.sync="dialog"
      width="600px"
      :close-on-click-modal="false"
      :before-close="closeDialog"
      class="entry-dialog"
    >
      <el-form class="entry-form" ref="entryForm" :model="entryForm" :rules="rules">
        <div class="row">
          <el-form-item label="仓库" prop="warehouseId" class="left">
            <el-select 
              class="white"
              clearable
              v-model="entryForm.warehouseId"
              placeholder="请选择仓库"
            >
              <el-option
                v-for="item in warehouseList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="货主：" prop="customerId">
            <el-select 
              class="white"
              clearable
              v-model="entryForm.customerId"
              placeholder="请选择货主"
              @change="changeEntryFormCustomerList"
            >
              <el-option
                v-for="item in customerList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="row">
          <el-form-item label="日期" prop="date" class="left">
            <el-date-picker
              v-model="entryForm.date"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择日期"
              clearable
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="项目名称："
            prop="projectId"
          >
            <el-select
              class="gray white"
              v-model="entryForm.projectId"
              placeholder="请选择项目"
            >
              <el-option
                v-for="item in entryFormProjectList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="title-content">
          <p>区域</p>
          <div>
            <span>库存总差异：</span>
            <span class="auto-calculation">自动计算</span>
          </div>
        </div>
        <div class="labor-info">
          <div class="labor-info-left">
            <p class="sub-title">库存区</p>
            <el-form-item label="盘盈" prop="stockInventorySurplus">
              <el-input
                class="gray white"
                v-model="entryForm.stockInventorySurplus"
                placeholder="请输入"
                @input="stockInventorySurplusInput(entryForm.stockInventorySurplus)"
                clearable
              ></el-input>
            </el-form-item>
            <el-form-item label="盘亏" prop="stockInventoryLoss">
              <el-input
                class="gray white"
                v-model="entryForm.stockInventoryLoss"
                placeholder="请输入"
                clearable
                @input="stockInventoryLossInput(entryForm.stockInventoryLoss)"
              ></el-input>
            </el-form-item>
          </div>
          <div class="labor-info-right">
            <p class="sub-title">拣选区</p>
            <el-form-item label="盘盈" prop="pickingInventorySurplus">
              <el-input
                class="gray white"
                v-model="entryForm.pickingInventorySurplus"
                placeholder="请输入"
                clearable
                @input="pickingInventorySurplusInput(entryForm.pickingInventorySurplus)"
              ></el-input>
            </el-form-item>
            <el-form-item label="盘亏" prop="pickingInventoryLoss">
              <el-input
                class="gray white"
                v-model="entryForm.pickingInventoryLoss"
                placeholder="请输入"
                clearable
                @input="pickingInventoryLossInput(entryForm.pickingInventoryLoss)"
              ></el-input>
            </el-form-item>
          </div>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button class="btn-white" @click="closeDialog">取消</el-button>
        <el-button class="btn-blue" @click="confirm('entryForm')">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import PaginationTpl from "components/base/PaginationTpl";
import Expenses from "models/expenses";
const expenses = new Expenses();
import Logistics from "models/logistics";
const logistics = new Logistics();
import ChargeRegister from "models/charge-register";
import Inventory from "models/data-entry/inventory";
import { inputAllTwoDecimal } from "common/js/util";
export default {
  components: {
    PaginationTpl
  },

  data() {
    return {
      total: 0,
      currentPage: 1,
      pageSize: 20,
      tableData: [],
      tableTitleList: [
        {label: '日期', prop: 'createTime', width: '150'},
        {label: '仓库', prop: 'warehouseName', width: ''},
        {label: '客户', prop: 'customerName', width: ''},
        {label: '项目', prop: 'projectName', width: ''},
      ],
      warehouseList: [],
      customerList: [],
      projectList: [],
      searchForm: {
        warehouseId: '',
        customerId: '',
        projectId: '',
        date: ''
      },

      
      dialog: false,
      entryFormProjectList: [],
      entryForm: {
        warehouseId: '',
        date: '',
        customerId: null,
        projectId: null,
        stockInventorySurplus: null,
        stockInventoryLoss: null,
        pickingInventorySurplus: null,
        pickingInventoryLoss: null,
      },
      rules: {
        warehouseId: [
          { required: true, message: '请选择仓库', trigger: 'change' }
        ],
        customerId: [
          { required: true, message: '请选择货主', trigger: 'change' }
        ],
        projectId: [
          { required: true, message: '请选择项目', trigger: 'change' }
        ],
        date: [
          { required: true, message: '请选择日期', trigger: 'change' }
        ]
      },
    }
  },

  created() {
    this.initList()
    this.getWarehouseList()
    this.getCustomerList()
  },

  methods: {
    //获取仓库数据
    getWarehouseList() {
      expenses.getWarehouseData().then(res => {
        if (res.success) {
          let arr = [];
          res.result.map(value => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.name;
            arr.push(obj);
          });
          this.warehouseList = arr;
        }
      });
    },

    /* 获取货主名称 */
    getCustomerList() {
      logistics.getCustomerData().then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.ordersName;
            arr.push(obj);
          });
          this.customerList = arr;
        }
      });
    },
    
    /* 获取项目名称 */
    initGetProjectList(type) {
      let customerId
      let warehouseId
      if (type === 'noEntry') {
        customerId = this.searchForm.customerId
        warehouseId = this.searchForm.warehouseId
      } else {
        customerId = this.entryForm.customerId
        warehouseId = this.entryForm.warehouseId
      }
      ChargeRegister.getProjectList(customerId, warehouseId).then((res) => {
        if (res.success) {
          let arr = [];
          res.result.map((value) => {
            let obj = {};
            obj.id = value.id;
            obj.name = value.projectsName;
            arr.push(obj);
          });
          if (type === 'noEntry') {
            this.projectList = arr;
            this.searchForm.projectId = arr.length > 0 ? arr[0].id : '';
          } else {
            this.entryFormProjectList = arr;
            this.entryForm.projectId = arr.length > 0 ? arr[0].id : '';
          }
        }
      });
    },

    initList() {
      let currentPage = this.currentPage
      let warehouseId = this.searchForm.warehouseId
      let customerId = this.searchForm.customerId
      let projectId = this.searchForm.projectId
      let reportDate = this.searchForm.date
      let data = {
        currentPage,
        warehouseId,
        customerId,
        projectId,
        reportDate
      }

      Inventory.getInventoryList(data).then(res => {
        if (res.success) {
          let arr = []
          this.total = res.result.totalNum
          this.pageSize = res.result.pageSize
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.createTime = i.reportDate
            obj.warehouseName = i.warehouseName
            obj.customerName = i.customerName
            obj.projectName = i.projectName
            obj.stockInventorySurplus = i.stockAreaSurplus
            obj.stockInventoryLoss = i.stockAreaLoss
            obj.pickingInventorySurplus = i.pickingAreaSurplus
            obj.pickingInventoryLoss = i.pickingAreaLoss
            obj.stockDifference = i.variance
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message.error(res.message)
        }
      })
    },
    
    changeCustomerList() {
      this.initGetProjectList('noEntry')
    },

    queryChange(data) {
      this.currentPage = data.currentPage;
      this.initList();
    },

    search() {
      this.currentPage = 1
      this.initList();
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    changeEntryFormCustomerList() {
      this.initGetProjectList('entry')
    },
    
    openEntry() {
      this.dialog = true
    },

    closeDialog() {
      this.entryForm.warehouseId = ''
      this.entryForm.date = ''
      this.entryForm.customerId = null
      this.entryForm.projectId = null
      this.entryForm.stockInventorySurplus = null
      this.entryForm.stockInventoryLoss = null
      this.entryForm.pickingInventorySurplus = null
      this.entryForm.pickingInventoryLoss = null
      this.dialog = false
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let warehouseId = this.entryForm.warehouseId
          let reportDate = this.entryForm.date
          let customerId = this.entryForm.customerId
          let projectId = this.entryForm.projectId
          let stockAreaSurplus = this.entryForm.stockInventorySurplus
          let stockAreaLoss = this.entryForm.stockInventoryLoss
          let pickingAreaSurplus = this.entryForm.pickingInventorySurplus
          let pickingAreaLoss = this.entryForm.pickingInventoryLoss
          let data = {
            warehouseId,
            reportDate,
            customerId,
            projectId,
            stockAreaSurplus,
            stockAreaLoss,
            pickingAreaSurplus,
            pickingAreaLoss,
          }
          Inventory.postEntryInventory(data).then(res => {
            if (res.success) {
              this.initList()
              this.closeDialog()
            } else {
              this.$message.error(res.message)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },

    stockInventorySurplusInput(v) {
      this.entryForm.stockInventorySurplus = inputAllTwoDecimal(v);
    },

    stockInventoryLossInput(v) {
      this.entryForm.stockInventoryLoss = inputAllTwoDecimal(v);
    },

    pickingInventorySurplusInput(v) {
      this.entryForm.pickingInventorySurplus = inputAllTwoDecimal(v);
    },

    pickingInventoryLossInput(v) {
      this.entryForm.pickingInventoryLoss = inputAllTwoDecimal(v);
    }
  }
}
</script>

<style lang='scss'>
.inventory {
  flex: 1;
  background: #fff;
  border-radius: 4px;
  box-sizing: border-box;
  .search {
    background: #fff;
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 20px;
    display: flex;
    justify-content: space-between;
    border-bottom: 1px solid #eee;
    .entry {
      padding: 0px 14px;
    }
    .el-form {
      min-height: 72px;
      .el-form-item {
        .el-date-editor {
          width: 192px;
        }
      }
      .row {
        display: flex;
        justify-content: flex-start;
        align-items: center;
      }
      .customer-form {
        .el-form-item__label {
          width: 50px!important;
        }
        .el-form-item__content {
          margin-left: 50px!important;
        }
      }
    }
    .operation-btn {
      padding-top: 48px;
    }
  }
  
  .table {
    padding: 16px;
  }
  .pagination {
    display: flex;
    justify-content: flex-end;
  }

  
  .entry-dialog {
    .el-dialog__header {
      border-bottom: 1px solid #eee;
      margin-bottom: 16px;
    }
    .entry-form {
      .row {
        display: flex;
        justify-content: flex-start;
        .el-form-item {
          width: 50%;
        }
        .left {
          margin-right: 30px;
        }
      }
      .el-form-item {
        .el-form-item__label {
          width: 100%;
          text-align: left;
        }
        .el-form-item__content,
        .el-select,
        .el-date-editor {
          width: 100%;
        }
      }
      .title-content {
        display: flex;
        justify-content: space-between;
        margin-bottom: 10px;
        font-size: 14px;
        font-weight: 400;
        color: #666666;
        .auto-calculation {
          color: #C9C9C9;
        }
      }
      .labor-info {
        padding: 20px;
        display: flex;
        justify-content: flex-start;
        border: 1px solid #eee;
        &-left {
          width: 50%;
          margin-right: 30px;
        }
        &-right {
          width: 50%;
        }
        .sub-title {
          padding-left: 5px;
          font-size: 14px;
          font-weight: 400;
          color: #666666;
          margin-bottom: 20px;
          border-left: 4px solid #2E68EA;
        }
      }
    }
    .el-dialog__footer {
      padding: 0px;
      .dialog-footer {
        border-top: 1px solid #eee;
        padding-top: 16px;
        padding-bottom: 16px;
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>
